import { Injectable, ErrorHandler } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {TdoUserParameters} from '../../models/configuration/user/tdo-user-parameters';

@Injectable({
    providedIn: 'root'
})
export class TdoSharedService
{
    constructor(private http: HttpClient) { }

    getUserParams(UserID: string, ParamName: string): Observable<TdoUserParameters> {
        console.log('loading user params');
        return this.http.get<TdoUserParameters>(`/api/accountReceivable/get-user-params/${UserID}/${ParamName}`);
    }

    saveUserParams( UserID: string, ParamName: string, ParamValue: string): Observable<number> {
        const payload = {
            paramValue: ParamValue,
        };
        //console.log('saving user param', UserID,ParamName, ParamValue);

        return this.http.post<number>(`/api/accountReceivable/save-user-params/${UserID}/${ParamName}`, payload);
    }



}


